import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=68152716&scoped=true&"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlans.vue?vue&type=style&index=0&id=68152716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68152716",
  null
  
)

export default component.exports